const EventsTopicCovered = () => {
  return (
    <>
      <h4 className="mb-3 text-1000 fs-xxl-6">Topic To Be Covered:</h4>
      <ul className="mb-6 ps-4">
        <li>Latest Update With Bitcoin</li>
        <li>Blockchain Vs Bitcoin</li>
        <li>Why Do We Need CryptoCurrency?</li>
        <li>Bitcoin History</li>
        <li>Bitcoin Vs Ethereum</li>
        <li>How Big Is Cryptocurrency Right Now?</li>
        <li>Crypto Scams &amp; How To Identify Them</li>
        <li>Is it Worth Buying To Keep?</li>
      </ul>
    </>
  );
};

export default EventsTopicCovered;
